module.exports = __webpack_public_path__ + "img/Infografis_EN_12.3d332de6.jpg";